import { iString, IString } from './IString';
import { DEFAULT_LOCALE_ID, LocaleId } from './LocaleId';
import type { StringId } from './StringId';
import stringsJson from './strings.json';

export function lookupString(
  id: StringId,
  locale?: LocaleId,
  warn = false
): string | undefined {
  const istring = stringsData.get(id);
  if (!istring) {
    if (warn) {
      console.warn(`Missing localized string for id: "${id}"`);
    }
    return undefined;
  }
  const effectiveLocale = locale ?? DEFAULT_LOCALE_ID;
  let raw = istring.get(effectiveLocale);
  if (!raw) {
    if (warn) {
      console.warn(
        `Missing localized string for id: "${id}" in locale: "${effectiveLocale}"`
      );
    }
    raw = istring.get(DEFAULT_LOCALE_ID);
    if (!raw) {
      if (warn) {
        console.warn(
          `No fallback string for id: "${id}" in locale: "${effectiveLocale}"`
        );
      }
      return undefined;
    }
  }
  if (raw.startsWith('!')) {
    return raw.slice(1).split('').reverse().join('');
  }
  return raw;
}

const stringsData: Map<StringId, IString> = (() => {
  const entries = stringsJson as unknown as {
    key: StringId;
    description: string;
    variants: Record<LocaleId, string>;
  }[];
  const map = new Map<StringId, IString>();
  for (const entry of entries) {
    const pairs = Object.entries(entry.variants) as [LocaleId, string][];
    const istring = iString(new Map(pairs), entry.description);
    map.set(entry.key, istring);
  }
  return map;
})();
